export const baseUrl = "https://development.jarvis.work:8080/api/"; // for development

// export const baseUrl = "http://localhost:8080/api/"; // for localhost

// export const baseUrl = "https://jarvis.work:8080/api/"; // for production
// export const baseUrl = "http://172.17.1.220:8080/api/"; // Sachin local (CF-All-5g)
// export const baseUrl = "http://172.17.0.116:8080/api/"; // Vijayant local (CF-All-5g)
// export const baseUrl = "https://172.17.0.66:8080/api/"; // sumit local (CF-All-5g)
// export const baseUrl = "http://172.17.0.208:8080/api/"; // aman local (CF-All-5g)
// export const baseUrl = "http://35.226.216.249:8080/api/"; // for development
export const insightsBaseUrl = "https://insights.ist:8080/api/"; // for insights production
// export const insightsBaseUrl = "https://172.17.1.144:8080/api/"; // for insights production
export const socketBaseUrl = "https://socket.jarvis.work:8080"; // for production
export const phpBaseUrl =
    "https://purchase.creativefuel.io/webservices/RestController.php"; // for production php
// ("https://purchase.creativefuel.io/webservices/RestController.php"); // for production php
// export const phpBaseUrl = 'https://ptest.creativefuel.io/webservices/RestController.php'; // for production php
// export const SECRET_KEY = "jarvisProdCryp$3912*secretKeyLogin"; // for encryption and decryption
export const SECRET_KEY = "jarvisdevelopmentCryp$3912*secretKeyLogin"; // for encryption and decryption for development
// export const SECRET_KEY = "jarvisdevelopmentCryp$3912*secretKeyLogin"; // for encryption and decryption
// export const SECRET_KEY = "jarvisProdCryp$3912*secretKeyLogin"; // for encryption and decryption
export const Is_Production = false; // Change this to true for production environment